<div class="p-grid">
	<div class="p-col-12 button-container center">
		<button pButton type="button" label="{{ 'button.picking' | translate }}"
				class="button" routerLink="/picking"
						icon="fas fa-truck-moving"></button>
	</div>
	<div class="p-col-12 button-container center">
		<button pButton type="button" label="{{ 'button.packing' | translate }}"
		class="button" routerLink="/packing" icon="fas fa-people-carry"></button>
	</div>
	<div class="p-col-12 button-container center">
		<button pButton type="button" label="{{ 'button.dispatchAndInvoicing' | translate }}"
		class="button" routerLink="/dispatchingandinvoicing" icon="fas fa-people-carry"></button>
	</div>
</div>
